import { links } from '@constants/styleQuiz';

export enum Flow {
  STYLE_QUIZ = 'STYLE_QUIZ',
  YOUR_NEEDS = 'YOUR_NEEDS',
}

export interface IQuestion {
  id: number | string;
  slug: string;
  flow: Flow | null;
  nextQuestion: IQuestion | null;
  uri?: string | null;
  nextUri?: string | null;
}

export default class Question implements IQuestion {
  /* eslint-disable lines-between-class-members */
  id: string | number;
  slug: string;
  flow: Flow | null;
  nextQuestion: IQuestion | null;

  constructor({
    id, slug, flow, nextQuestion
  }: IQuestion) {
    this.id = id;
    this.slug = slug;
    this.flow = flow;
    this.nextQuestion = nextQuestion;
  }

  get uri(): string | null {
    if (!this.flow) return null;
    return this.flow === Flow.STYLE_QUIZ
      ? `${links.STYLE_QUIZ}/${this.slug}`
      : `${links.YOUR_NEEDS}/${this.slug}`;
  }

  get nextUri(): string | null {
    return this.nextQuestion?.uri ?? null;
  }
}
